import headerComponent from '@/components/cust_components/cust_header_component.vue';
import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)
import axios from 'axios';

export default {
    name: 'signup',
    components:{
        headerComponent,
    
    },
    data(){
        return {
            mobile_view : false,
            status_selected : '61',
            first_name:'',
            first_name_validation:'',
            all_validations_passed:true,
            last_name:'',
            last_name_validation:'',
            cust_email:'',
            email_exists:'',
            cust_mobile:'',
            mobile_validation:'',
            cust_country_isd_code:'',
            cust_time_zone:'',
            password:'',
            password_validation:'',
            passwordFieldType: 'password',
            confirm_password:'',
            confirm_password_validation : '',
            confirmPwdFieldType : 'password',
            pwd_img : 'password_close_icon.svg',
            confirm_pwd_img :'password_close_icon.svg',
            isClicked : false,
            cust_details : {},
            start_time_exist:'',
            service_details:''

           
        }
    },
    mounted(){
        if(this.$session.get('cust_details') &&  !this.$session.get('preview_booking_flag'))
        {
            this.$router.push('/mybookings');
        }
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
    },
    methods:{
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth) 
        },
        login(){
            this.$router.push('/custlogin')
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
              evt.preventDefault();
            } else {
              return true;
            }
        },
        switchVisibilityPassword() {
            
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            this.pwd_img =   this.passwordFieldType === 'password' ? 'password_close_icon.svg' : 'password_show_icon.svg';

        },
        switchVisibilityConfirmPwd(){
            this.confirmPwdFieldType = this.confirmPwdFieldType === 'password' ? 'text' : 'password'
            this.confirm_pwd_img =   this.confirmPwdFieldType === 'password' ? 'password_close_icon.svg' : 'password_show_icon.svg';

        },
        mobile_input_field()
        {
            document.getElementById("country_code_dropdown").style.border = "1px solid #FB6672";
        },
        first_name_validation_check(){
            this.first_name = this.first_name.trim();
            this.first_name_validation = '';
            if(this.first_name.length == 0){
                this.all_validations_passed = false 
                this.first_name_validation = 'Please enter valid first name'
            }
        },
        last_name_validation_check(){
            this.last_name = this.last_name.trim();
            this.last_name_validation = ''
            if(this.last_name.length == 0){
                this.all_validations_passed = false 
                this.last_name_validation = 'Please enter valid last name'
            }
        },
        check_customer_exists(){
            if(this.$store.state.regx.test(this.cust_email)){
                axios.post(this.$store.state.api +'v2/customer/check_cust_email_exists_v2',{
                    cust_email:this.cust_email
                }).then(result=>{
                    if(result.data.result.customer.length > 0){
                        this.email_exists = 'This email is already in use, please use another.'
                    }
                    else this.email_exists = '';
                })
            }
            else {
                if(this.cust_email.length == 0)
                {
                    this.email_exists = 'Please enter valid email eddress'
                }
                else{
                    this.email_exists = 'Invalid email address'
                }
            }
        },
        mobile_number_validation_check(){
            this.cust_mobile = this.cust_mobile.trim();
            this.mobile_validation = '';
            if(this.cust_mobile.length <= 0){
                this.all_validations_passed = false ;
                this.mobile_validation = 'Please enter valid mobile number'
            }
            else if(this.cust_mobile.length < 9 || this.cust_mobile.length > 11){
                this.all_validations_passed = false 
                this.mobile_validation = 'Please enter valid 9-12 digit mobile number'
            }
            document.getElementById("country_code_dropdown").style.border = "none";
        },
        password_validation_check(){
            this.password= this.password.trim();
            this.password_validation = ''
            if(this.password.length == 0){
                this.all_validations_passed = false 
                this.password_validation = 'Please enter valid password'
            }
        },
        confirm_password_validation_check(){
            this.confirm_password= this.confirm_password.trim();
            this.confirm_password_validation = ''
            if(this.confirm_password.length == 0){
                this.all_validations_passed = false 
                this.confirm_password_validation = 'Please enter valid password'
            }
            if(this.password!=this.confirm_password){
                this.all_validations_passed = false 
                this.confirm_password_validation = 'Password not matched'
            }
        },
        validation_check(){
            this.all_validations_passed = true;
            this.mobile_number_validation_check();
            this.first_name_validation_check();
            this.last_name_validation_check();
            this.password_validation_check();
            this.confirm_password_validation_check();
            if(this.email_exists.length){
                this.all_validations_passed = false
            }
            if(!this.cust_email) this.email_exists = 'Please enter valid email address'
        },
        submit(){
            this.Constants.time_zones.forEach(zone => {
                if(this.status_selected == zone.country_code){this.cust_time_zone = zone.time_zone}
            })
            this.validation_check()
            if(this.all_validations_passed){
               this.isClicked = true;
                var ciphertext = this.CryptoJS.AES.encrypt(this.password,this.Constants.CRYPTO_KEY).toString();
                this.first_name = this.first_name.toLowerCase();
                this.last_name = this.last_name.toLowerCase();
                axios.post(this.$store.state.api +'v2/customer/signup_v2',{
                    "cust_first_name" :    this.first_name.charAt(0).toUpperCase() + this.first_name.slice(1),
                    "cust_last_name"  :    this.last_name.charAt(0).toUpperCase() + this.last_name.slice(1),
                    "cust_email"      :    this.cust_email.toLowerCase(),
                    "cust_country_isd_code":this.status_selected,
                    "cust_mobile"          :this.cust_mobile,
                    "password"             :ciphertext,
                }).then(response =>{
                    this.isClicked = false;
                    if (response.status === 200) {
                        this.cust_details = JSON.stringify({
                            cust_first_name :  response.data.result.cust_first_name,
                            cust_last_name  :  response.data.result.cust_last_name,
                            cust_email      :  response.data.result.cust_email,
                        });
                        this.$session.set('cust_details',  this.cust_details);

                        if(this.$session.get('service_obj')){
                            this.service_details = JSON.parse(this.$session.get('service_obj'));
                        }
                        if(this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0){
                           this.start_time_exist =  this.service_details.every(serv_obj => Object.keys(serv_obj).includes('slot_start_time'))
                        
                        }
                       
                        if(this.service_details && this.start_time_exist){
                            this.$router.push('/terms');  
                        } 
                        else if(this.service_details && !this.start_time_exist){
                            this.$router.push('/cart');  
                        } 
                        else{
                            this.$router.push('/mybookings');
                        }    
                    }

                })
            }
        }

    }
}